import { ultraMarine } from '@cogneed/react-utils';
import { Backdrop, CircularProgress, styled } from '@mui/material';

const StyledBackdrop = styled(Backdrop)({
  color: ultraMarine['500'],
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
});

export default function LoadingBackdrop() {
  return (
    <StyledBackdrop open sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}>
      <CircularProgress color="inherit" />
    </StyledBackdrop>
  );
}
